export function formatDateTime(value) {
  const raw = value ?? null;
  if (!raw) return "—";
  const d = typeof raw === "string" ? new Date(raw) : raw;
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("ru-RU", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatDate(value) {
  const raw = value ?? null;
  if (!raw) return "—";
  const d = typeof raw === "string" ? new Date(raw) : raw;
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("ru-RU", {
    day: "numeric",
    month: "long",
  });
}
